import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { ActivatedRoute, NavigationEnd, Router, RouterModule } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { filter } from 'rxjs';

@Component({
  selector: 'app-manual-creation',
  standalone: true,
  imports: [RouterModule, MatIconModule,CommonModule],
  templateUrl: './manual-creation.component.html',
  styleUrl: './manual-creation.component.scss'
})
export class ManualCreationComponent {
  classroomId: string='';
  showSidebar = true;
  constructor(private router: Router,private route: ActivatedRoute,private _toastr: ToastrService) { }

ngOnInit(): void {
  this.route.paramMap.subscribe(params => {
    this.classroomId = params.get('classroomId') ?? '';
  });

  const hideRoutes = ['course-preview', 'some-other-route'];
  const currentUrl = this.router.url;
  this.showSidebar = !hideRoutes.some(route => currentUrl.includes(route));
  this.router.events
    .pipe(filter(event => event instanceof NavigationEnd))
    .subscribe((event: any) => {
      this.showSidebar = !hideRoutes.some(route => event.url.includes(route));
    });
}


goBack(): void {
  if (this.classroomId) {
    this.router.navigate([
      '/teacher-dashboard',
      'classroom-detail-page',
      this.classroomId,
      'courses'
    ]);
  } else {
    this._toastr.error('Classroom ID not found!');
  }
}
}
